module.exports = __webpack_public_path__ + "media/4.eb5f24cc.mp3";